import { camelizeKeys } from 'humps'

const bookingPlugin = (state = {}, {type, payload}) => {
  switch (type) {
    case 'BOOKING_PLUGIN.INIT':
      const selectedSize = Object.keys(payload.field_sizes)[0]
      return {
        ...state,
        ...camelizeKeys(payload),
        selectedSize: selectedSize,
        selectedDate: moment(payload.date),
        selectedDuration: '1',
        intervals: [],
        selectedInterval: {},
        step: 'field',
        person: {},
        isLoading: false,
        alert: null
      }
    case 'BOOKING_PLUGIN.BOOK_MORE':
      return {
        ...state,
        selectedSize: Object.keys(state.fieldSizes)[0],
        selectedDate: moment(state.date),
        selectedDuration: '1',
        intervals: [],
        selectedInterval: {},
        step: 'field',
        person: {},
        isLoading: false,
        alert: null
      }
    case 'BOOKING_PLUGIN.SELECT_SIZE':
      return {...state, selectedSize: payload }
    case 'BOOKING_PLUGIN.SELECT_DATE':
      return {...state, selectedDate: payload }
    case 'BOOKING_PLUGIN.SELECT_DURATION':
      return {...state, selectedDuration: payload }
    case 'BOOKING_PLUGIN.SET_STEP':
      return {...state, step: payload }
    case 'BOOKING_PLUGIN.SET_LOADING':
      return {...state, isLoading: payload }
    case 'BOOKING_PLUGIN.SET_INTERVALS':
      return {...state, intervals: payload, selectedInterval: {}, price: null }
    case 'BOOKING_PLUGIN.SELECT_INTERVAL':
      return {...state, selectedInterval: payload }
    case 'BOOKING_PLUGIN.SET_PRICE':
      return {...state, price: payload }
    case 'BOOKING_PLUGIN.SET_PERSON':
      return {...state, person: payload }
    case 'BOOKING_PLUGIN.SET_ALERT':
      return {...state, alert: payload}
    default:
      return state
  }
}

export default bookingPlugin
